<app-menu [stickyInput]="true"></app-menu>
<app-article-detail [articleData]="article"></app-article-detail>
<app-sponsors></app-sponsors>
<app-footer></app-footer>
